import { host, logoUrl } from '@natu/utils/paths';

import { SBProps } from '../../../../utils';

type SBCollectionPageJsonLdProps = {
  name?: string;
  headline?: string;
  description?: string;
  parentProps?: {
    firstPublishedAt?: string;
    updatedAt?: string;
    slug?: string;
  };
  hasPart?: Array<{
    name?: string;
    full_slug?: string;
    content?: {
      collectionSchemaDescription?: string;
    };
  }>;
};

export const SBCollectionPageJsonLd = ({ blok }: SBProps<SBCollectionPageJsonLdProps>) => {
  const { name, headline, description, hasPart, parentProps } = blok;

  const pageUrl = parentProps?.slug ? `${host}/${parentProps.slug}` : host;

  const hasPartData =
    hasPart
      ?.map(part => ({
        '@type': 'CreativeWork',
        name: part?.name || '',
        url: (part.full_slug === 'home' ? host : `${host}/${part.full_slug}`) || '',
        description: part.content?.collectionSchemaDescription || '',
      }))
      .filter(Boolean) || [];

  const collectionSchema = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    '@id': pageUrl,
    url: pageUrl,
    name: name || '',
    headline: headline || name || '',
    description: description || '',
    datePublished: parentProps?.firstPublishedAt || new Date().toISOString(),
    dateModified: parentProps?.updatedAt || new Date().toISOString(),
    inLanguage: 'en',
    publisher: {
      '@type': 'Organization',
      name: 'Naturaily',
      url: host,
      logo: {
        '@type': 'ImageObject',
        url: logoUrl,
      },
    },
    hasPart: hasPartData,
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(collectionSchema) }}
    />
  );
};
